import { createBrowserRouter } from 'react-router'
import { RequireAuth, Shell } from '@/components/Shell'
import { AccountPage } from '@/features/AccountPage'
import { ForgotPage, LoginPage, SignupPage } from '@/features/AuthPages'
import { ChargePage } from '@/features/ChargePage'
import { ChargingPage } from '@/features/ChargingPage'
import { HistoryPage } from '@/features/HistoryPage'
import { MapPage } from '@/features/MapPage'
import { ChargerLink, StationPage } from '@/features/StationPage'
import { WalletPage } from '@/features/WalletPage'
import { TopUpResultPage } from '@/features/TopUp'
import { ReceiptPage } from '@/features/ReceiptPage'
import { HelpPage } from '@/features/HelpPage'
import { RoutePage } from '@/features/RoutePage'
import { EmptyState } from '@/components/common'
import { RouteError } from '@/components/RouteError'

const auth = (el: React.ReactNode) => <RequireAuth>{el}</RequireAuth>

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage />, errorElement: <RouteError /> },
  { path: '/signup', element: <SignupPage />, errorElement: <RouteError /> },
  { path: '/forgot', element: <ForgotPage />, errorElement: <RouteError /> },
  {
    element: <Shell />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <MapPage /> },
      { path: 'stations/:id', element: <StationPage /> },
      { path: 'c/:chargerId', element: <ChargerLink /> },
      { path: 'c/:chargerId/:connector', element: <ChargerLink /> },
      { path: 'charge/:chargerId/:connector', element: auth(<ChargePage />) },
      { path: 'charging', element: auth(<ChargingPage />) },
      { path: 'history', element: auth(<HistoryPage />) },
      { path: 'wallet', element: auth(<WalletPage />) },
      // Not behind login: the payment may have been made from the app's browser.
      { path: 'wallet/topup', element: <TopUpResultPage /> },
      { path: 'account', element: auth(<AccountPage />) },
      { path: 'receipts/:id', element: auth(<ReceiptPage />) },
      { path: 'help', element: <HelpPage /> },
      { path: 'route', element: <RoutePage /> },
      { path: '*', element: <EmptyState title="Page not found" /> },
    ],
  },
])
